import Box from '@totallymoney/ui/components/Box'
import CategoryNavigation from '@totallymoney/ui/components/CategoryNavigation'
import Grid from '@totallymoney/ui/components/Grid'

import {
    CreditCardProductCategory,
    ScoredCreditCardProductsCategory,
} from '@appTypes/EligibilityApi.interface'

import TableSorter from '@components/TableSorter'

import useAppQueryState from '@hooks/useAppQueryState'

import { getUnscoredCategoryPath } from '@utils/getUnscoredCategoryPath'

interface TableHeaderProps {
    activeCategory: CreditCardProductCategory
    categories: ScoredCreditCardProductsCategory[]
    onCategoryChange: (category: CreditCardProductCategory) => void
    onSortChange: (sortKey: string) => void
    sortOptions: Record<string, string>
    sortValue: string
}

const UnscoredTableHeader = ({
    activeCategory,
    categories,
    sortValue,
    sortOptions,
    onSortChange,
    onCategoryChange,
}: TableHeaderProps) => {
    const { goToRouteWithAppState, getRouteUrl } = useAppQueryState()

    return (
        <Grid>
            <Box gridColumn="1/13" ml="-space10">
                <CategoryNavigation
                    categories={categories.map(category => ({
                        displayName: category.displayName,
                        value: category.id,
                        url: getRouteUrl(getUnscoredCategoryPath(category.id)),
                    }))}
                    hasPadding={false}
                    initialActiveCategory={activeCategory}
                    onCategoryChange={category => {
                        const categoryValue =
                            category.value as CreditCardProductCategory

                        const newCategoryPages = [
                            CreditCardProductCategory.BalanceTransfer,
                            CreditCardProductCategory.Cashback,
                            CreditCardProductCategory.Combined,
                            CreditCardProductCategory.PoorCredit,
                            CreditCardProductCategory.Purchase,
                            CreditCardProductCategory.Rewards,
                            CreditCardProductCategory.Travel,
                        ]

                        const categoryIsLegacyPage =
                            !newCategoryPages.includes(categoryValue)

                        goToRouteWithAppState(
                            getUnscoredCategoryPath(categoryValue),
                            {
                                shallow: true,
                            }
                        )

                        if (categoryIsLegacyPage) {
                            onCategoryChange?.(categoryValue)
                        }
                    }}
                />
            </Box>

            <Box gridColumn={['1/13', '9/13']} mt={['space20', 'space30']}>
                <TableSorter
                    value={sortValue}
                    sortOptions={sortOptions}
                    onSortChange={sortKey => {
                        onSortChange?.(sortKey)
                    }}
                />
            </Box>
        </Grid>
    )
}

export default UnscoredTableHeader
